import { http } from './httpClient'
import type { Plan } from './types'

interface PlanListEnvelope {
  results?: Plan[]
  count?: number
  next?: string | null
  previous?: string | null
}

function normalizePlanList(payload: Plan[] | PlanListEnvelope): Plan[] {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload.results)) return payload.results
  return []
}

function normalizePlan(plan: Plan): Plan {
  const allowTeamMembers = plan.allow_team_members ?? plan.allows_team ?? false
  return {
    ...plan,
    monthly_price_cents: plan.monthly_price_cents ?? plan.price_cents,
    allow_team_members: allowTeamMembers,
    allows_team: allowTeamMembers,
    max_history_per_project: plan.max_history_per_project ?? null,
  }
}

export const planApi = {
  list: async () =>
    normalizePlanList(
      // Backend usa paginação default; precisamos extrair `results`.
      await http.get<Plan[] | PlanListEnvelope>('/api/plans/'),
    ).map(normalizePlan),
}
